<template>
<div class="resetpass-form">
  <h3 class="title">{{$t('register')}}</h3>
  <p class="tips">{{$t('Please_fill_in_the_true_and_valid_information')}}</p>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    hide-required-asterisk
    v-loading="loading"
  >
<!--    <p>{{$t('name')}}</p>-->
    <p>{{$t('family_name')}}</p>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item
          prop="lastName"
        >
          <el-input
            v-emoji
            :placeholder="$t('family_name')"
            v-model="form.lastName"
            name="username"
            maxlength="30"
            class="w-full">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="familyName"
        >
          <el-input
            v-emoji
            :placeholder="$t('Register.lastName')"
            v-model="form.familyName"
            name="username"
            maxlength="30"
            class="w-full">
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item
      :label="$t('email')"
      prop="email"
    >
      <el-input
        :placeholder="$t('please_input')"
        v-model="form.email"
        name="email"
        class="w-full">
      </el-input>
    </el-form-item>
    <el-form-item
      :label="$t('mobile_phone')"
      prop="phone"
      class="no-need-border-radiu"
    >
      <el-input
        :placeholder="$t('please_input')"
        v-model="form.phone"
        name="phone"
        @input="phoneInputHandle"
        class="w-full">
        <el-select
          style="width: 80px;"
          slot="prepend"
          :placeholder="$t('root.selectPls')"
          v-model="phoneTitle"
          @change = "changePhone"
          filterable
        >
          <el-option
            v-for="option in phoneList"
            :key="option.value"
            :label="option.label"
            :value="option.label"
          >
            <span>{{`${option.label} ${option.description}`}}</span>
          </el-option>
        </el-select>
      </el-input>
    </el-form-item>
    <el-form-item
      :label="$t('Verification_mode')"
      prop="veriCode"
      class="no-need-border-radiu prepend-not-select-item"
    >
      <el-input
        :placeholder="$t('please_input')"
        v-model="form.veriCode"
        class="w-full"
      >
        <el-select
          style="width: 80px;"
          v-show="phoneTitle =='+86'"
          slot="prepend"
          :placeholder="$t('root.selectPls')"
          v-model="veriCodeType"
        >
          <el-option
            v-for="option in veriCodeTypeList"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          >
          </el-option>
        </el-select>


        <el-select
          style="width: 80px;"
          v-show="phoneTitle !='+86'"
          slot="prepend"
          :placeholder="$t('root.selectPls')"
          v-model="veriCodeType"
          disabled
        >
          <el-option
            v-for="option in veriCodeTypeList"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          >
          </el-option>
        </el-select>
        <div
          class="code-suffix theme-color pointer"
          slot="suffix">
          <span
            class="code-btn-text active"
            v-if="!isCountDownStart"
                @click="getCode"
          >{{$t('Send_verification_code')}}</span>
          <span class="code-btn-text" v-else>{{countDown}}s {{$t('Register.againVer')}}</span>
        </div>
      </el-input>
    </el-form-item>
    <el-form-item
      :label="$t('password')"
      prop="newPsw"
      :show-message="false"
      class="has-text-content"
    >
      <el-input
        v-model="form.newPsw"
        show-password
        maxlength="20"
        :placeholder="$t('please_input')"
      ></el-input>
      <p class="pass-strong-level one-level"
         :class="{
                          on: oneLevelFlag == true,
                         nopass: oneLevelFlag == false,
                     }"
      >
        <span class="circle pass-strong-circle"></span>
        <span>{{$t('limitRegistPassOneStep')}}</span>
      </p>
      <p class="pass-strong-level two-level"
         :class="{
                       on: twoLevelFlag,
                            nopass: twoLevelFlag == false,
                       }"
      >
        <span class="circle pass-strong-circle"></span>
        <span>{{$t('limitRegistPassTwoStep')}}</span>
      </p>
    </el-form-item>
    <el-form-item
      prop="rePsw"
      :label="$t('Register.rePswText')"
    >
      <el-input
        type="password"
        v-model="form.rePsw"
        show-password
        maxlength="20"
        :placeholder="$t('Register.rePswText')"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <vs-button
        class="w-full mt-6"
        color="primary"
        type="filled"
        size="large"
        @click="registHandle"
      >{{$t('register')}}</vs-button>
    </el-form-item>
  </el-form>
  <p class="center">
    {{$t('Already_have_an_account')}}?
    <span
      @click="toLogin"
      class="theme-color pointer">{{$t('To_log_in')}}</span>
  </p>
</div>
</template>

<script>
import { setLocalStorage } from '@/utils/common';
import { passFisrtStrong, passSecondStrong, validatEmail,strongPwd,limitNumber,isMobile } from "@/utils/validate";
import { RegisterPost,getSendVerEmail } from '@/api/user'
import { getDictListByType } from "@/api/home";
export default {
  name: "registForm",
  data() {
    var validateUserName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('please_enter')));
      } else {
        if(SPECIALCHAR_RULE.test(value)){
          callback(new Error(this.$t('Usernames_are_not_allowed_to_contain_special_characters')));
        }else {
          callback();
        }
      }
    };
    let _this = this;
    var validateEmailCurrent = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_this.$t('please_input_your_email')));
      } else {
        if(!validatEmail(value)){
          callback(new Error(_this.$t('Please_enter_the_email_address_in_the_correct_format')));
        }else {
          callback();
        }
      }
    };

    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_this.$t('phoneEmtpyTips')));
      } else {
        if(_this.phoneTitle !== '+86'){
          callback();
        }else {
          if(!isMobile(value)){
            callback(new Error(_this.$t('Register.errorPhon')));
          }else {
            callback();
          }
        }
      }
    };

    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_this.$t('Register.notpassword')));
      } else {
        if(!strongPwd(value)){
          callback(new Error(_this.$t('Register.passwordDes')));
        }else {
          callback();
        }
      }
    };
    var validateRePsw = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_this.$t('Register.rePswText')));
      } else {
        if(value !== _this.form.newPsw){
          callback(new Error(_this.$t('Register.notrepassword')));
        }else {
          callback();
        }
      }
    };
    return {
      phoneTitle: '+86',

      veriCodeTypeList: [
        { label: _this.$t('mobile_phone'), value: 1 },
        { label: _this.$t('email'), value: 2 },
      ],
      form:{
        familyName: '',
        lastName: '',
        email: '',
        phone: '',
        veriCode: '',
        newPsw: '',
        rePsw: '',
      },
      rules:{
        familyName: [
          // { required: true, message: _this.$t('User.nameNullMessage'), trigger: 'blur' },
          { validator: validateUserName, trigger: ['blur', 'change'] },
        ],
        lastName: [
          // { required: true, message: _this.$t('Register.errorFirstName'), trigger: 'blur' }
          { validator: validateUserName, trigger: ['blur', 'change'] },
        ],
        email: [
          // 另外引入邮箱的正则验证
          {
            validator: validateEmailCurrent,
            trigger: 'blur'
          },
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' },
          /*{ required: true, message: _this.$t('Please_enter_the_phone_number'), trigger: 'blur' }*/
        ],
        veriCode: [
          { required: true, message: _this.$t('Partner.inputVer'), trigger: 'blur' }
        ],
        newPsw: [
          { validator: validatePass, trigger: 'blur' }
        ],
        rePsw: [
          { validator: validateRePsw, trigger: 'blur' }
        ],
      },
      phoneList: [],
      countDown: 60,
      isCountDownStart: false, // 是否开始倒计时
      querys: null,
      loading: false,
      veriCodeType:1
    }
  },
  created(){
    this.querys = this.$route.query;
    this.getPhoneList();
  },
  computed: {
    oneLevelFlag(){
      if(this.form.newPsw !== ''){
        return passFisrtStrong(this.form.newPsw);
      }
    },
    twoLevelFlag(){
      if(this.form.newPsw !== ''){
        return passSecondStrong(this.form.newPsw);
      }
    }
  },
  methods: {
    setLocalStorage,
    getCode(){
      this.$refs.form.validateField('email', (error) => {
        if(!error){
          this.$refs.form.validateField('phone', (error) => {
            if(!error){
              let nationality = 0;
              if(this.veriCodeType == 1){
                nationality = 1;
              }else if(this.veriCodeType == 2){
                nationality = 2;
              }
              getSendVerEmail({
                phone: this.form.phone,
                nationCode: this.phoneTitle,
                // nationality: this.form.nation,
                nationality: nationality,
                email: this.form.email,
                verType:this.veriCodeType
              }).then((res) => {
                this.isCountDownStart = true;
                this.countDown = 60;
                let countDownId = setInterval(() => {
                  if (this.countDown <= 0) {
                    clearInterval(countDownId);
                    this.isCountDownStart = false;
                    this.countDown = 60;
                    return;
                  }
                  this.countDown -= 1;
                }, 1000);
              })
            }
          })
        }
      })
    },
    getPhoneList(){
      let parmas = {
        type: 'phoneList'
      };
      getDictListByType(parmas).then((res) => {
        this.phoneList = res.data;
      });
    },
    registHandle(){
      this.$refs.form.validate((valid) => {
        if(valid){
          // 要重新联调
          this.loading = true;
          let parmas = {
            password: this.$md5(this.form.rePsw.trim()),
            phone: this.form.phone.trim(),
            email: this.form.email.trim(),
            firstName: this.form.lastName.trim(),
            lastName: this.form.familyName.trim(),
            nationCode: this.phoneTitle,
            phoneVerCode: this.form.veriCode,
            verType:this.veriCodeType
            // nationality: this.form.nation,已经去掉了
          };
          if (this.querys) {
            parmas = Object.assign(this.querys, parmas);
          }
          RegisterPost(parmas).then((res) => {
            this.loading = false;
            localStorage.setItem('token', res.data.token);
            this.setLocalStorage('userInfo', res.data.cust);

            this.$store.commit('setUserInfo', res.data.cust);
            this.setLocalStorage('custStatus', res.data.cust.custStatus);
            if(res.data.cust.custStatus == 1){
              this.$router.push({
                name: 'perfectInfo'
              });
            }else if (res.data.cust.custStatus == 10) {
              // 注册提交成功
              this.$emit('regist-success');
            }
          }).catch((err) => {
            this.loading = false;
          })
        }else {
          console.log('error validate');
        }
      });
    },
    toLogin(){
      this.$router.push({name: 'login'});
    },
    phoneInputHandle(){
      this.form.phone = limitNumber(this.form.phone);
    },
    changePhone(){
      if(this.phoneTitle == '+86'){
        this.veriCodeType = 1;
      }else {
        this.veriCodeType = 2;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.resetpass-form {
  .prepend-not-select-item {
    /deep/ .el-input-group__prepend {
      background-color: #FAFAFA!important;
      color: #333333;
    }
  }

  /deep/ .el-input__inner {
    border: 1px solid #D8D6DE;
    border-radius: 5px;
  }
  /deep/ .el-form-item__content {
    line-height: 10px;
  }
  /deep/ .el-form-item {
    margin-bottom: 15px;
  }
  /deep/ .el-form-item__label {
    padding-bottom: 5px;
    line-height: 14px;
  }

  .text-p {
    margin-bottom: 7px;
    margin-top: 7px;
  }
  .tips {
    margin-bottom: 40px;
    margin-top: 10px;
  }
  .pass-strong-level {
    margin-top: 10px;
  }
}
</style>
<style lang="scss">
.resetpass-form {
  .no-need-border-radiu {
    .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>
